// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ArticleList_wrapper__kn7v6","title":"ArticleList_title__IVbzj"};